<div
  class="breadcrumb__container"
  [ngClass]="{ '--has-overflow': isOverflowing }"
>
  <ol class="breadcrumb__list" #breadcrumbList>
    @for (item of data; track $index) {
      @if (!item.isActiveChapter) {
        <li class="breadcrumb__item">
          <a [routerLink]="item.url_tree" class="breadcrumb__link" tabindex="0">
            {{ item.title }}
          </a>
        </li>
      }
    }
    @if (showTitle && title) {
      <li class="breadcrumb__item">
        <span class="breadcrumb__title">
          {{ title }}
        </span>
      </li>
    }
  </ol>

  <div
    class="breadcrumb__scroll-btn --start"
    [ngClass]="{ 'd-none': isAtStart }"
  >
    <button mat-icon-button (click)="scrollLeft()" [disabled]="isAtStart">
      <mat-icon>chevron_left</mat-icon>
    </button>
  </div>

  <div class="breadcrumb__scroll-btn --end" [ngClass]="{ 'd-none': isAtEnd }">
    <button mat-icon-button (click)="scrollRight()" [disabled]="isAtEnd">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
